import { render, staticRenderFns } from "./consume.vue?vue&type=template&id=63190432&"
import script from "./consume.vue?vue&type=script&lang=js&"
export * from "./consume.vue?vue&type=script&lang=js&"
import style0 from "./consume.vue?vue&type=style&index=0&id=63190432&prod&lang=less&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports